<template>
  <div>
    <logged-in-header />
    <clients />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import clients from "../components/clients/Clients";

export default {
  components: {
    loggedInHeader,
    clients
  }
};
</script>
